webpackJsonp([151854149278528],{

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactObfuscate = __webpack_require__(420);
	
	var _reactObfuscate2 = _interopRequireDefault(_reactObfuscate);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Main = __webpack_require__(40);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Article = __webpack_require__(39);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PageHeader = __webpack_require__(45);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(44);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _config = __webpack_require__(43);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Seo = __webpack_require__(76);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _Footer = __webpack_require__(105);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {};
	};
	
	var Discreet = function Discreet() {
	  var _ref, _ref2, _ref3, _ref4;
	
	  var data = {
	    frontmatter: {
	      title: "Discreet head protection",
	      description: "Discreet head protection for surfing that can go under hats, wetsuit hoods or squid lids.  While none of these options are going to prevent head injury in any way, they might reduce the severity a tad."
	    }
	  };
	  var facebook = {};
	  return _react2.default.createElement(
	    _Main2.default,
	    null,
	    _react2.default.createElement(
	      _Article2.default,
	      null,
	      _react2.default.createElement(_PageHeader2.default, {
	        title: "Discreet head protection",
	        subTitle: "Under hat, wetsuit hood, or squid lid"
	      }),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Gamebreaker Stealth Helmet Liner"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895574/project_surf_helmet/stealth_liner_wfskau.png",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              null,
	              "Pros"
	            ),
	            _react2.default.createElement(
	              "th",
	              null,
	              "Cons"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "No bulging when sewn in"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Requires sewing or adhesive"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Could achieve near-full coverage"
	            ),
	            _react2.default.createElement("td", null)
	          )
	        ),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Idea"
	        ),
	        ": The Gamebreaker Stealth Liner made from D3O could be sewn into or adhered inside any hat, wetsuit hood or squid lid, providing a little protection with little to no hit on surfing performance or looks.",
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://gamebreaker.com/shop/stealth-helmet-liner/",
	                target: "_blank",
	                style: (_ref = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref["textAlign"] = "center", _ref.paddingLeft = "20px", _ref.paddingRight = "20px", _ref.height = "45px", _ref.minWidth = "100px", _ref.backgroundColor = "inherit", _ref.color = "#010101", _ref["border"] = "1px solid #010101", _ref["fontWeight"] = 600, _ref.textDecoration = "none", _ref.paddingTop = "7.5px", _ref.paddingBottom = "8.5px", _ref)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://amzn.to/2ZUrOLJ",
	                target: "_blank",
	                style: (_ref2 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref2["textAlign"] = "center", _ref2.paddingLeft = "20px", _ref2.paddingRight = "20px", _ref2.height = "47px", _ref2.minWidth = "100px", _ref2.backgroundColor = "#ee5a5a", _ref2.marginLeft = "30px", _ref2["fontWeight"] = 600, _ref2.textDecoration = "none", _ref2.paddingTop = "9px", _ref2.paddingBottom = "10px", _ref2)
	              },
	              "Amazon price"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "2nd Skull Protective Skull Cap"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895626/project_surf_helmet/2nd_skull_cap_btr73l.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              null,
	              "Pros"
	            ),
	            _react2.default.createElement(
	              "th",
	              null,
	              "Cons"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Ready to go"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Bulges and moves easily"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Very light, minimal"
	            ),
	            _react2.default.createElement("td", null)
	          )
	        ),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": Works great under a tight-fitting wetsuit hood. Otherwise, it will move and bulge easily. Might be better to place under a tight squid lid or",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://amzn.to/37UdB5N", target: "_blank" },
	          "indo-style hat"
	        ),
	        ". Or even under the",
	        " ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/reviews/dmc-soft-surf-helmet/" },
	          "DMC Soft Surf Helmet"
	        ),
	        " for a little more protection. There's also a",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://amzn.to/2ZXYiVm", target: "_blank" },
	          "pro version"
	        ),
	        " ",
	        "with a slip surface for better rotational protection under hard-shell helmets.",
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://2ndskull.com/products/black-skull-cap",
	                target: "_blank",
	                style: (_ref3 = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref3["textAlign"] = "center", _ref3.paddingLeft = "20px", _ref3.paddingRight = "20px", _ref3.height = "45px", _ref3.minWidth = "100px", _ref3.backgroundColor = "inherit", _ref3.color = "#010101", _ref3["border"] = "1px solid #010101", _ref3["fontWeight"] = 600, _ref3.textDecoration = "none", _ref3.paddingTop = "7.5px", _ref3.paddingBottom = "8.5px", _ref3)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://amzn.to/2MCmsBO",
	                target: "_blank",
	                style: (_ref4 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref4["textAlign"] = "center", _ref4.paddingLeft = "20px", _ref4.paddingRight = "20px", _ref4.height = "47px", _ref4.minWidth = "100px", _ref4.backgroundColor = "#ee5a5a", _ref4.marginLeft = "30px", _ref4["fontWeight"] = 600, _ref4.textDecoration = "none", _ref4.paddingTop = "9px", _ref4.paddingBottom = "10px", _ref4)
	              },
	              "Amazon price"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { footnote: data }),
	    _react2.default.createElement(_Seo2.default, { data: data, facebook: facebook, page: true })
	  );
	};
	
	Discreet.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Discreet);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-discreet-js-120eceac07e8bdc9f8d6.js